import React from 'react';
import moment from 'moment-timezone';
import {
  Badge,
  CalendarTimeZoneUtil,
  DateUtil,
  Layout,
  LayoutItem,
} from '@axiom/ui';
import type { UserInterview } from '@axiom/validation';

import { InterviewGridDateAndRoundUtil } from '../../utils/interview-grid-date-and-round-util';

export type InterviewGridDateAndRoundProps = {
  data: UserInterview;
};

export const InterviewGridDateAndRound = ({
  data,
}: InterviewGridDateAndRoundProps) => {
  const dateAtTime =
    DateUtil.displayDateAtTime(data.calendarConversation?.startTime) ?? null;
  const dateAtTimeWithTimezone = dateAtTime
    ? `${dateAtTime} ${
        CalendarTimeZoneUtil.getZoneFromMomentZone(
          moment.tz(new Date(), moment.tz.guess())
        )?.abbr ?? ''
      }`
    : null;
  return (
    <Layout name="DATE_TIME_ROUND_LAYOUT">
      <LayoutItem name="DATE_TIME_ITEM">{dateAtTimeWithTimezone}</LayoutItem>
      <LayoutItem name="ROUND_ITEM" fluid position="right">
        {data.interviewNumber > 1 ? (
          <Badge name="INTERVIEW_ROUND_BADGE" background="light blue">
            {InterviewGridDateAndRoundUtil.countBadgeLabel(
              data.interviewNumber
            )}
          </Badge>
        ) : null}
      </LayoutItem>
    </Layout>
  );
};
